import React from 'react';
import "./index.css"
import assets from "../../../../../../util/assets";
import PropTypes from "prop-types";
import Ucert from "../../../../../../assets/images/U CERT.svg";
import CommonImageCard from "../../../../../CommonImageCard";


const getPricingStatus = (pricing) => {
    if (pricing.part_of_subscription === "yes") {
        if (pricing.type === "free") {
            return "free";
        } else {
            return "premium";
        }
    } else {
        if (pricing.type === "free") {
            return "free";
        } else {
            return "exclusive";
        }
    }
}

function PricingType(props) {

    let pricingStatus = "free";

    if (props.hasOwnProperty("pricingStatus")) {
        pricingStatus = props.pricingStatus;
    } else {
        pricingStatus = getPricingStatus(props.content.pricing);
    }
    if (pricingStatus === "free") {
        return (<div/>)
    } else if (pricingStatus === "premium" || pricingStatus === "paid") {
        return (
            <div className="home-container-list-video-time-container" style={{backgroundColor:'transparent'}}>
                <img src={assets.clipstore.premium} className={"age-group-24"}/>
            </div>
        )
    } else {
        return (
            <div className="home-container-list-video-time-container" style={{backgroundColor:'transparent'}}>
                <img src={assets.clipstore.exclusive} className={"age-group-24"}/>
            </div>
        )
    }
}

PricingType.propTypes = {
    content: PropTypes.object.isRequired,
    pricingStatus: PropTypes.string,
};

PricingType.defaultProps = {
}

export default PricingType;